// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/dc-count.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qp-dropdown-profile.qp-dropdown {
  left: auto;
  right: -20px;
  top: 44px;
}

.profile-dropdown-menu .account-link {
  text-decoration: none;
  cursor: pointer;
}
.profile-dropdown-menu ul li {
  font-weight: 600;
}
.profile-dropdown-menu .btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.profile-dropdown-menu {
  min-width: 315px;
  max-width: 315px;
  font-size: 12px;
  background-color: #fff;
  border-bottom: 1px solid #a3a3a3;
  border-left: 1px solid #a3a3a3;
}

.profile-dropdown-menu .account-list {
  border: none;
  padding: 0;
}

.profile-dropdown-menu .account-list ul > li {
  border-bottom: 1px solid #dcdcdc;
  display: block;
  padding: 13px 15px;
  position: relative;
  transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
  z-index: 1;
}

.profile-dropdown-menu .account-list ul > li:hover {
  background-color: #ededed;
}

.profile-dropdown-menu .account-list ul > li:first-of-type {
  background-color: #fff;
}

.profile-dropdown-menu .account-list ul > li:first-of-type .account-link:first-of-type {
  margin-bottom: 10px;
}

.notification-group > ul > li.user-avatar .profile-dropdown-menu .account-list ul > li:first-of-type > .account-link:nth-child(2) > span.small-text {
  width: 75%;
}

.profile-dropdown-menu .account-list ul > li:nth-child(2) {
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  position: relative;
}

.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link {
  padding-bottom: 7px;
  padding-top: 7px;
}

.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:first-of-type {
  padding-top: 10px;
}

.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:nth-child(3) {
  padding-bottom: 10px;
}

.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:hover:after {
  background-color: #ccc;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -200px;
  right: -200px;
  z-index: -1;
}

.profile-dropdown-menu .account-list ul > li:last-child {
  border-bottom: none;
}

.profile-dropdown-menu .account-list ul > li > .fa {
  width: 28px;
  color: #74808e;
  font-size: 18px;
  left: 20px;
  position: absolute;
  text-align: center;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  z-index: 1;
}

.profile-dropdown-menu .account-list ul > li > .account-link {
  color: #74808e;
  display: block;
  padding-left: 60px;
  position: relative;
  transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover {
  color: #74808e;
  text-decoration: none;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover ~ .fa {
  text-decoration: none;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover .btn {
  border: 1px solid #1b87e6;
  color: #1b87e6;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover .small-text {
  color: #0093ea;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification {
  color: #74808e;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification .note {
  color: #8a8bb9;
}

.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification .small-text {
  color: #808792;
}

.profile-dropdown-menu .account-list ul > li > .account-link .btn {
  background: 0 0;
  border: 1px solid #757c87;
  border-radius: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  margin-top: 5px;
  padding: 5px 5px 3px 5px;
  text-transform: uppercase;
}

.profile-dropdown-menu .account-list ul > li > .account-link .small-text {
  color: #808792;
  display: block;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  white-space: nowrap;
}

.profile-dropdown-menu .account-list ul > li > .account-link .small-text.light {
  font-weight: 300;
}

.profile-dropdown-menu .account-list ul > li > .account-link .progress-bar {
  width: 70%;
  height: 3px;
  background: #d7d7d7;
  box-shadow: none;
  display: block;
  float: none;
  margin: 4px auto 0;
}

.profile-dropdown-menu .account-list ul > li > .account-link .progress-bar > span {
  height: 100%;
  background: #7ed221;
  display: block;
  float: left;
}

.profile-dropdown-menu .account-list ul > li > .account-link .account-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown-menu .account-list ul > li > .account-link .my-notification {
  width: 84px;
  font-weight: 300;
  line-height: 13px;
  position: absolute;
  right: -15px;
  text-align: center;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
}

.profile-dropdown-menu .account-list ul > li > .account-link .note {
  float: none;
  font-size: 12px;
}

.profile-dropdown-menu .bottom-info {
  height: 69px;
  background: #4c5060;
  border-top: 1px solid #dcdcdc;
  box-shadow: 0 -2px 2px -2px rgba(0, 0, 0, 0.176);
  padding: 0 15px 0 0;
}

.profile-dropdown-menu .bottom-info .area-info {
  float: left;
  padding: 0 15px;
  height: 100%;
  transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
}

.profile-dropdown-menu .bottom-info .area-info .map {
  width: 42px;
  height: 18px;
  background-size: cover;
  display: block;
  margin-left: 30px;
  position: relative;
}

.profile-dropdown-menu .bottom-info .area-info .map:before {
  content: "\\f1c0";
  font-family: FontAwesome;
  font-size: 18px;
  left: -25px;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
}

.profile-dropdown-menu .bottom-info .area-info .country-name {
  display: block;
  font-size: 10px;
  font-weight: 300;
  margin-top: 6px;
  text-align: center;
  text-transform: uppercase;
}

.profile-dropdown-menu .bottom-info .area-info:hover {
  background: #fff;
  cursor: pointer;
  color: #4c5060;
}
.profile-dropdown-menu .bottom-info .area-info:hover span {
  transition: none;
}

.profile-dropdown-menu .bottom-info .area-info:hover .country-name {
  color: #4c5060;
  cursor: pointer;
}

.profile-dropdown-menu .bottom-info .area-info:hover .map:before {
  color: #4c5060;
}

.profile-dropdown-menu .bottom-info .logout-btn {
  max-width: 160px;
  border: 1px solid #fff;
  color: #fff;
  font-size: 12px;
  float: right;
  padding: 7px 15px 5px 30px;
  position: relative;
  text-transform: uppercase;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
}

.profile-dropdown-menu .bottom-info .logout-btn:before {
  content: "\\f08b";
  font-family: FontAwesome;
  font-size: 15px;
  left: 10px;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
}

.profile-dropdown-menu .bottom-info .logout-btn:hover {
  background: #fff;
  color: #4c5060;
}

.profile-dropdown-menu .bottom-info .logout-btn:hover:before {
  color: #4c5060;
}

.area-info {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
}

.area-info-icons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
.area-info-icons img {
  height: 30px;
  width: 40px;
  object-fit: contain;
}

.area-info-label {
  display: block;
  font-size: 10px;
  font-weight: 300;
  text-align: center;
  text-transform: uppercase;
}

@media only screen and (min-width: 970px) {
  #QPDataCenter .modal-dialog {
    width: 840px;
  }
}
#dataCenter {
  max-width: 900px;
  border-radius: 0;
  font-family: "Fira Sans", sans-serif;
}

#dataCenter .modal-dialog {
  width: 90%;
  max-width: none;
  min-width: auto;
}

@media only screen and (min-width: 970px) {
  #dataCenter .modal-dialog {
    width: 840px;
  }
}
#dataCenter .modal-content .panel-header {
  background: #0a86ea;
  line-height: 36px;
  margin: 0;
  padding: 0;
  position: relative;
}

#dataCenter .modal-content .panel-header .heading {
  width: 100%;
  color: #fff;
  display: inline-block;
  font-size: 18px;
  font-weight: 300;
  margin: 0;
  padding: 0;
  text-align: center;
}

#dataCenter .modal-content .panel-header .close {
  color: #fff;
  font-size: 32px;
  font-weight: 400;
  opacity: 1;
  position: absolute;
  right: 10px;
  top: 2px;
}

#dataCenter .title {
  width: 98%;
  border: 1px solid #e5e5e5;
  box-shadow: 0 2px 3px 0 #dedede;
  color: #a1a1a1;
  text-align: center;
  margin: 15px 1%;
  padding: 8px 0;
}

#dataCenter .dc-content {
  width: 100%;
  display: block;
  padding: 15px;
}

@media only screen and (min-width: 970px) {
  #dataCenter .dc-content {
    display: table;
    table-layout: fixed;
  }
}
#dataCenter .dc-content .dc-image,
#dataCenter .dc-content .dc-table {
  width: 100%;
  display: inline-block;
}

@media only screen and (min-width: 970px) {
  #dataCenter .dc-content .dc-image,
#dataCenter .dc-content .dc-table {
    width: 50%;
    display: table-cell;
    vertical-align: top;
  }
}
#dataCenter .dc-content .dc-table table {
  width: 100%;
}

#dataCenter .dc-content .dc-table table tr td,
#dataCenter .dc-content .dc-table table tr th {
  border-bottom: none;
  border-right: 1px solid #ececec;
  border-top: none;
  font-size: 12px;
  padding: 10px;
}

#dataCenter .dc-content .dc-table table tr td:first-of-type {
  border-left: 1px solid #ececec;
  border-right: none;
  font-weight: 500;
}

#dataCenter .dc-content .dc-table table tr td .fa {
  color: #7ed320;
  font-size: 8px;
}

#dataCenter .dc-content .dc-table table tr td:nth-child(3) {
  text-align: center;
}

#dataCenter .dc-content .dc-table table tr td .dc-count {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: auto auto;
  display: inline-block;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.one {
  background-position: 0 0;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.two {
  background-position: -15px 0;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.three {
  background-position: -30px 0;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.four {
  background-position: -45px 0;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.five {
  background-position: -60px 0;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.six {
  background-position: 0 -18px;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.seven {
  background-position: -15px -18px;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.eight {
  background-position: -30px -18px;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.nine {
  background-position: -45px -18px;
}

#dataCenter .dc-content .dc-table table tr td .dc-count.zero {
  background-position: -60px -18px;
}

#dataCenter .dc-content .dc-table table tr td .surveys {
  display: inline-block;
  font-size: 16px;
  margin-left: 2px;
  vertical-align: top;
}

#dataCenter .dc-content .dc-table table tr th {
  background: #f6f6f6;
  font-weight: 500;
}

#dataCenter .dc-content .dc-table table tr th:first-of-type {
  border-left: 1px solid #ececec;
}

#dataCenter .dc-content .dc-table table tr:last-child {
  border-bottom: 1px solid #ececec;
}

#dataCenter .dc-content .dc-image {
  padding-left: 15px;
  vertical-align: middle;
}

#dataCenter .dc-content .dc-image img {
  width: 100%;
  max-width: 100%;
}

#dataCenter .action-btn {
  padding: 5px 15px;
  text-align: right;
}

#dataCenter .action-btn .dc-btn {
  background: #1b88e7;
  border: none;
  color: #fff;
  line-height: 1.5;
  outline: 0;
  padding: 5px 10px;
}

#dataCenter .action-btn .dc-btn:hover {
  background: #1671c0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/scss/profile-dropdown.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,YAAA;EACA,SAAA;AAAR;;AAKI;EACI,qBAAA;EACA,eAAA;AAFR;AAMQ;EACI,gBAAA;AAJZ;AAQI;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,6BAAA;EACA,kBAAA;AANR;;AAUA;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;AAPJ;;AASA;EACI,YAAA;EACA,UAAA;AANJ;;AAQA;EACI,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,yCAAA;EACA,UAAA;AALJ;;AAOA;EACI,yBAAA;AAJJ;;AAMA;EACI,sBAAA;AAHJ;;AAKA;EACI,mBAAA;AAFJ;;AAIA;EASI,UAAA;AATJ;;AAWA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AARJ;;AAUA;EACI,mBAAA;EACA,gBAAA;AAPJ;;AASA;EACI,iBAAA;AANJ;;AAQA;EACI,oBAAA;AALJ;;AAOA;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAJJ;;AAMA;EACI,mBAAA;AAHJ;;AAKA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,UAAA;AAFJ;;AAIA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,yCAAA;AADJ;;AAGA;EACI,cAAA;EACA,qBAAA;AAAJ;;AAEA;EACI,qBAAA;AACJ;;AACA;EACI,yBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,cAAA;AAGJ;;AADA;EACI,cAAA;AAIJ;;AAFA;EACI,cAAA;AAKJ;;AAHA;EACI,cAAA;AAMJ;;AAJA;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;AAOJ;;AALA;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAQJ;;AANA;EACI,gBAAA;AASJ;;AAPA;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAUJ;;AARA;EACI,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAWJ;;AATA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAYJ;;AAVA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;AAaJ;;AAXA;EACI,WAAA;EACA,eAAA;AAcJ;;AAZA;EACI,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,gDAAA;EACA,mBAAA;AAeJ;;AAbA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,yCAAA;AAgBJ;;AAdA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAiBJ;;AAfA;EACI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;AAkBJ;;AAhBA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAmBJ;;AAjBA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAoBJ;AAnBI;EACI,gBAAA;AAqBR;;AAlBA;EACI,cAAA;EACA,eAAA;AAqBJ;;AAnBA;EACI,cAAA;AAsBJ;;AApBA;EACI,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,yCAAA;AAuBJ;;AArBA;EACI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;AAwBJ;;AAtBA;EACI,gBAAA;EACA,cAAA;AAyBJ;;AAvBA;EACI,cAAA;AA0BJ;;AAxBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AA2BJ;;AAxBA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AA2BJ;AA1BI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AA4BR;;AAxBA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA2BJ;;AAvBA;EACI;IACI,YAAA;EA0BN;AACF;AAxBA;EACI,gBAAA;EACA,gBAAA;EACA,oCAAA;AA0BJ;;AAxBA;EACI,UAAA;EACA,eAAA;EACA,eAAA;AA2BJ;;AAzBA;EACI;IACI,YAAA;EA4BN;AACF;AA1BA;EACI,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AA4BJ;;AA1BA;EACI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AA6BJ;;AA3BA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AA8BJ;;AA5BA;EACI,UAAA;EACA,yBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA+BJ;;AA7BA;EACI,WAAA;EACA,cAAA;EACA,aAAA;AAgCJ;;AA9BA;EACI;IACI,cAAA;IACA,mBAAA;EAiCN;AACF;AA/BA;;EAEI,WAAA;EACA,qBAAA;AAiCJ;;AA/BA;EACI;;IAEI,UAAA;IACA,mBAAA;IACA,mBAAA;EAkCN;AACF;AAhCA;EACI,WAAA;AAkCJ;;AAhCA;;EAEI,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAmCJ;;AAjCA;EACI,8BAAA;EACA,kBAAA;EACA,gBAAA;AAoCJ;;AAlCA;EACI,cAAA;EACA,cAAA;AAqCJ;;AAnCA;EACI,kBAAA;AAsCJ;;AApCA;EACI,WAAA;EACA,YAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,qBAAA;AAuCJ;;AArCA;EACI,wBAAA;AAwCJ;;AAtCA;EACI,4BAAA;AAyCJ;;AAvCA;EACI,4BAAA;AA0CJ;;AAxCA;EACI,4BAAA;AA2CJ;;AAzCA;EACI,4BAAA;AA4CJ;;AA1CA;EACI,4BAAA;AA6CJ;;AA3CA;EACI,gCAAA;AA8CJ;;AA5CA;EACI,gCAAA;AA+CJ;;AA7CA;EACI,gCAAA;AAgDJ;;AA9CA;EACI,gCAAA;AAiDJ;;AA/CA;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAkDJ;;AAhDA;EACI,mBAAA;EACA,gBAAA;AAmDJ;;AAjDA;EACI,8BAAA;AAoDJ;;AAlDA;EACI,gCAAA;AAqDJ;;AAnDA;EACI,kBAAA;EACA,sBAAA;AAsDJ;;AApDA;EACI,WAAA;EACA,eAAA;AAuDJ;;AArDA;EACI,iBAAA;EACA,iBAAA;AAwDJ;;AAtDA;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAyDJ;;AAvDA;EACI,mBAAA;EACA,eAAA;AA0DJ","sourcesContent":[".qp-dropdown-profile {\n    &.qp-dropdown {\n        left: auto;\n        right: -20px;\n        top: 44px;\n    }\n}\n\n.profile-dropdown-menu {\n    .account-link {\n        text-decoration: none;\n        cursor: pointer;\n    }\n\n    ul {\n        li {\n            font-weight: 600;\n        }\n    }\n\n    .btn {\n        display: inline-block;\n        padding: 6px 12px;\n        margin-bottom: 0;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1.42857143;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: middle;\n        -ms-touch-action: manipulation;\n        touch-action: manipulation;\n        cursor: pointer;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        border: 1px solid transparent;\n        border-radius: 4px;\n    }\n}\n\n.profile-dropdown-menu {\n    min-width: 315px;\n    max-width: 315px;\n    font-size: 12px;\n    background-color: #fff;\n    border-bottom: 1px solid #a3a3a3;\n    border-left: 1px solid #a3a3a3;\n}\n.profile-dropdown-menu .account-list {\n    border: none;\n    padding: 0;\n}\n.profile-dropdown-menu .account-list ul > li {\n    border-bottom: 1px solid #dcdcdc;\n    display: block;\n    padding: 13px 15px;\n    position: relative;\n    transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    -webkit-transition: all 0.15s ease-in-out;\n    z-index: 1;\n}\n.profile-dropdown-menu .account-list ul > li:hover {\n    background-color: #ededed;\n}\n.profile-dropdown-menu .account-list ul > li:first-of-type {\n    background-color: #fff;\n}\n.profile-dropdown-menu .account-list ul > li:first-of-type .account-link:first-of-type {\n    margin-bottom: 10px;\n}\n.notification-group\n    > ul\n    > li.user-avatar\n    .profile-dropdown-menu\n    .account-list\n    ul\n    > li:first-of-type\n    > .account-link:nth-child(2)\n    > span.small-text {\n    width: 75%;\n}\n.profile-dropdown-menu .account-list ul > li:nth-child(2) {\n    padding-top: 0;\n    padding-bottom: 0;\n    overflow: hidden;\n    position: relative;\n}\n.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link {\n    padding-bottom: 7px;\n    padding-top: 7px;\n}\n.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:first-of-type {\n    padding-top: 10px;\n}\n.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:nth-child(3) {\n    padding-bottom: 10px;\n}\n.profile-dropdown-menu .account-list ul > li:nth-child(2) > .account-link:hover:after {\n    background-color: #ccc;\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -200px;\n    right: -200px;\n    z-index: -1;\n}\n.profile-dropdown-menu .account-list ul > li:last-child {\n    border-bottom: none;\n}\n.profile-dropdown-menu .account-list ul > li > .fa {\n    width: 28px;\n    color: #74808e;\n    font-size: 18px;\n    left: 20px;\n    position: absolute;\n    text-align: center;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -moz-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n    z-index: 1;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link {\n    color: #74808e;\n    display: block;\n    padding-left: 60px;\n    position: relative;\n    transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    -webkit-transition: all 0.15s ease-in-out;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover {\n    color: #74808e;\n    text-decoration: none;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover ~ .fa {\n    text-decoration: none;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover .btn {\n    border: 1px solid #1b87e6;\n    color: #1b87e6;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover .small-text {\n    color: #0093ea;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification {\n    color: #74808e;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification .note {\n    color: #8a8bb9;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link:hover .my-notification .small-text {\n    color: #808792;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .btn {\n    background: 0 0;\n    border: 1px solid #757c87;\n    border-radius: 0;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 15px;\n    margin-top: 5px;\n    padding: 5px 5px 3px 5px;\n    text-transform: uppercase;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .small-text {\n    color: #808792;\n    display: block;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n    white-space: nowrap;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .small-text.light {\n    font-weight: 300;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .progress-bar {\n    width: 70%;\n    height: 3px;\n    background: #d7d7d7;\n    box-shadow: none;\n    display: block;\n    float: none;\n    margin: 4px auto 0;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .progress-bar > span {\n    height: 100%;\n    background: #7ed221;\n    display: block;\n    float: left;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .account-ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .my-notification {\n    width: 84px;\n    font-weight: 300;\n    line-height: 13px;\n    position: absolute;\n    right: -15px;\n    text-align: center;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -moz-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n}\n.profile-dropdown-menu .account-list ul > li > .account-link .note {\n    float: none;\n    font-size: 12px;\n}\n.profile-dropdown-menu .bottom-info {\n    height: 69px;\n    background: #4c5060;\n    border-top: 1px solid #dcdcdc;\n    box-shadow: 0 -2px 2px -2px rgba(0, 0, 0, 0.176);\n    padding: 0 15px 0 0;\n}\n.profile-dropdown-menu .bottom-info .area-info {\n    float: left;\n    padding: 0 15px;\n    height: 100%;\n    transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    -webkit-transition: all 0.15s ease-in-out;\n}\n.profile-dropdown-menu .bottom-info .area-info .map {\n    width: 42px;\n    height: 18px;\n    background-size: cover;\n    display: block;\n    margin-left: 30px;\n    position: relative;\n}\n.profile-dropdown-menu .bottom-info .area-info .map:before {\n    content: \"\\f1c0\";\n    font-family: FontAwesome;\n    font-size: 18px;\n    left: -25px;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -moz-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n}\n.profile-dropdown-menu .bottom-info .area-info .country-name {\n    display: block;\n    font-size: 10px;\n    font-weight: 300;\n    margin-top: 6px;\n    text-align: center;\n    text-transform: uppercase;\n}\n.profile-dropdown-menu .bottom-info .area-info:hover {\n    background: #fff;\n    cursor: pointer;\n    color: #4c5060;\n    span {\n        transition: none;\n    }\n}\n.profile-dropdown-menu .bottom-info .area-info:hover .country-name {\n    color: #4c5060;\n    cursor: pointer;\n}\n.profile-dropdown-menu .bottom-info .area-info:hover .map:before {\n    color: #4c5060;\n}\n.profile-dropdown-menu .bottom-info .logout-btn {\n    max-width: 160px;\n    border: 1px solid #fff;\n    color: #fff;\n    font-size: 12px;\n    float: right;\n    padding: 7px 15px 5px 30px;\n    position: relative;\n    text-transform: uppercase;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -moz-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n    transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    -webkit-transition: all 0.15s ease-in-out;\n}\n.profile-dropdown-menu .bottom-info .logout-btn:before {\n    content: \"\\f08b\";\n    font-family: FontAwesome;\n    font-size: 15px;\n    left: 10px;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -moz-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    -o-transform: translate(0, -50%);\n}\n.profile-dropdown-menu .bottom-info .logout-btn:hover {\n    background: #fff;\n    color: #4c5060;\n}\n.profile-dropdown-menu .bottom-info .logout-btn:hover:before {\n    color: #4c5060;\n}\n.area-info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    color: #fff;\n}\n\n.area-info-icons {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    width: 100%;\n    img {\n        height: 30px;\n        width: 40px;\n        object-fit: contain;\n    }\n}\n\n.area-info-label {\n    display: block;\n    font-size: 10px;\n    font-weight: 300;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n// Data center modal layout\n@media only screen and (min-width: 970px) {\n    #QPDataCenter .modal-dialog {\n        width: 840px;\n    }\n}\n#dataCenter {\n    max-width: 900px;\n    border-radius: 0;\n    font-family: \"Fira Sans\", sans-serif;\n}\n#dataCenter .modal-dialog {\n    width: 90%;\n    max-width: none;\n    min-width: auto;\n}\n@media only screen and (min-width: 970px) {\n    #dataCenter .modal-dialog {\n        width: 840px;\n    }\n}\n#dataCenter .modal-content .panel-header {\n    background: #0a86ea;\n    line-height: 36px;\n    margin: 0;\n    padding: 0;\n    position: relative;\n}\n#dataCenter .modal-content .panel-header .heading {\n    width: 100%;\n    color: #fff;\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 300;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n#dataCenter .modal-content .panel-header .close {\n    color: #fff;\n    font-size: 32px;\n    font-weight: 400;\n    opacity: 1;\n    position: absolute;\n    right: 10px;\n    top: 2px;\n}\n#dataCenter .title {\n    width: 98%;\n    border: 1px solid #e5e5e5;\n    box-shadow: 0 2px 3px 0 #dedede;\n    color: #a1a1a1;\n    text-align: center;\n    margin: 15px 1%;\n    padding: 8px 0;\n}\n#dataCenter .dc-content {\n    width: 100%;\n    display: block;\n    padding: 15px;\n}\n@media only screen and (min-width: 970px) {\n    #dataCenter .dc-content {\n        display: table;\n        table-layout: fixed;\n    }\n}\n#dataCenter .dc-content .dc-image,\n#dataCenter .dc-content .dc-table {\n    width: 100%;\n    display: inline-block;\n}\n@media only screen and (min-width: 970px) {\n    #dataCenter .dc-content .dc-image,\n    #dataCenter .dc-content .dc-table {\n        width: 50%;\n        display: table-cell;\n        vertical-align: top;\n    }\n}\n#dataCenter .dc-content .dc-table table {\n    width: 100%;\n}\n#dataCenter .dc-content .dc-table table tr td,\n#dataCenter .dc-content .dc-table table tr th {\n    border-bottom: none;\n    border-right: 1px solid #ececec;\n    border-top: none;\n    font-size: 12px;\n    padding: 10px;\n}\n#dataCenter .dc-content .dc-table table tr td:first-of-type {\n    border-left: 1px solid #ececec;\n    border-right: none;\n    font-weight: 500;\n}\n#dataCenter .dc-content .dc-table table tr td .fa {\n    color: #7ed320;\n    font-size: 8px;\n}\n#dataCenter .dc-content .dc-table table tr td:nth-child(3) {\n    text-align: center;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count {\n    width: 16px;\n    height: 18px;\n    background-image: url(\"./../../images/dc-count.png\");\n    background-repeat: no-repeat;\n    background-size: auto auto;\n    display: inline-block;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.one {\n    background-position: 0 0;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.two {\n    background-position: -15px 0;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.three {\n    background-position: -30px 0;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.four {\n    background-position: -45px 0;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.five {\n    background-position: -60px 0;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.six {\n    background-position: 0 -18px;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.seven {\n    background-position: -15px -18px;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.eight {\n    background-position: -30px -18px;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.nine {\n    background-position: -45px -18px;\n}\n#dataCenter .dc-content .dc-table table tr td .dc-count.zero {\n    background-position: -60px -18px;\n}\n#dataCenter .dc-content .dc-table table tr td .surveys {\n    display: inline-block;\n    font-size: 16px;\n    margin-left: 2px;\n    vertical-align: top;\n}\n#dataCenter .dc-content .dc-table table tr th {\n    background: #f6f6f6;\n    font-weight: 500;\n}\n#dataCenter .dc-content .dc-table table tr th:first-of-type {\n    border-left: 1px solid #ececec;\n}\n#dataCenter .dc-content .dc-table table tr:last-child {\n    border-bottom: 1px solid #ececec;\n}\n#dataCenter .dc-content .dc-image {\n    padding-left: 15px;\n    vertical-align: middle;\n}\n#dataCenter .dc-content .dc-image img {\n    width: 100%;\n    max-width: 100%;\n}\n#dataCenter .action-btn {\n    padding: 5px 15px;\n    text-align: right;\n}\n#dataCenter .action-btn .dc-btn {\n    background: #1b88e7;\n    border: none;\n    color: #fff;\n    line-height: 1.5;\n    outline: 0;\n    padding: 5px 10px;\n}\n#dataCenter .action-btn .dc-btn:hover {\n    background: #1671c0;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
